import React from 'react';

const formatContactLine = ({ phone, email }) => {
  const safePhone = phone ? String(phone).trim() : '';
  const safeEmail = email ? String(email).trim() : '';
  if (safePhone && safeEmail) {
    return `${safePhone} | ${safeEmail}`;
  }
  if (safePhone) {
    return safePhone;
  }
  if (safeEmail) {
    return safeEmail;
  }
  return 'Add phone in Profile';
};

const renderFallbackLogo = (text) => {
  const value = String(text || '').trim();
  if (!value) return null;
  if (value.includes('&')) {
    const [first, ...rest] = value.split('&');
    const remainder = rest.join('&').trim();
    return (
      <div className="business-card-logo-text">
        <span>{first.trim()} &amp;</span>
        <span>{remainder}</span>
      </div>
    );
  }
  return <div className="business-card-logo-text">{value}</div>;
};

const BusinessCardPreview = React.forwardRef(
  ({ logoUrl, fullName, designation, phone, email, fallbackLogoText, variant = 'back' }, ref) => (
    <div className={`business-card ${variant}`} ref={ref}>
      <div className="business-card-logo">
        {logoUrl ? (
          <img src={logoUrl} alt="Douglas & McCartney logo" crossOrigin="anonymous" />
        ) : (
          renderFallbackLogo(fallbackLogoText)
        )}
      </div>
      {variant !== 'front' && (
        <div className="business-card-details">
          <div className="business-card-name">{fullName || 'Your Name'}</div>
          <div className="business-card-title">{designation || 'Senior Property Advisor'}</div>
          <div className="business-card-contact">
            {formatContactLine({ phone, email })}
          </div>
        </div>
      )}
    </div>
  ),
);

BusinessCardPreview.displayName = 'BusinessCardPreview';

export default BusinessCardPreview;
